import React from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";

import LoanProceedsForm from "./LoanProceedsForm";
import AnalysisResult from "./AnalysisResult";

const FormWrapper = styled(Grid)`
  height:100%;  
`;
const ResultWrapper = styled(Grid)`  
  &&&& {
    max-width: 100%;
  }
`;
const LoanProceeds = () => (
  <Grid container justify="space-between" spacing={24}>
    <FormWrapper item xs={5} lg={7} style={{ marginBottom: "20px" }}>
      <LoanProceedsForm />
    </FormWrapper>
    <ResultWrapper item xs={6} lg={4}>
      <AnalysisResult />
    </ResultWrapper>
    <div item lg={1} />
  </Grid>
);

export default LoanProceeds;
